import React from "react";
import { css } from "@emotion/react";

type Props = {
    className?: string,
};

const ProfileIcon: React.FC<Props> = ({ className = "" }) => {
    const style = css`
        display: flex;
        justify-content: center;

        > svg {
            width: 43px;
            height: 43px;
        }
    `;

    return (
        <div css={style} className={className}>
            <svg viewBox="0 0 1080 1080">
                <defs>
                    <clipPath id={`clip-profile`}>
                        <circle cx="538.49" cy="544.4" r="427.81" fill="#1d8bdb" />
                    </clipPath>
                </defs>
                <g>
                    <circle cx="538.49" cy="544.4" r="525.6" fill="#1d8bdb" />
                    <circle cx="538.49" cy="422.17" r="134.45" fill="white" />
                    <g clipPath={`url(#clip-profile)`}>
                        <ellipse cx="538.49" cy="911.1" rx="256.69" ry="305.58" fill="white" />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default ProfileIcon;
